export const LOGIN_RESPONSE = "LOGIN_RESPONSE";
export const LOGIN_VIA_ACCESS_TOKEN = "LOGIN_VIA_ACCESS_TOKEN";
export const PRE_LOGIN_DATA = "PRE_LOGIN_DATA";
export const LOGOUT = "LOGOUT";
export const LOADER = "LOADER";
export const ON_DROPDOWN_CHANGE_HEADER = "ON_DROPDOWN_CHANGE_HEADER";
